import { Component, Input } from '@angular/core';

import { NavOverflowExtendedData } from '../../interfaces/nav-overflow-extended-data.interface';
import { NgIf } from '@angular/common';
import { ActionNavOverflowMenuComponent } from '../action-nav-overflow-menu/action-nav-overflow-menu.component';
import { PendingChipComponent } from '../pending-chip/pending-chip.component';

@Component({
    selector: 'zci-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    imports: [
        NgIf,
        ActionNavOverflowMenuComponent,
        PendingChipComponent,
    ],
})
export class TileComponent {
    @Input() navOverflowMenuConfig: NavOverflowExtendedData;

    @Input() isRequestPending: boolean;
}
